import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import type { TooltipProps } from 'recharts';
import { fmt } from '../format.ts';
import type { SpiderRow } from '../types.ts';

function RadarTooltip({ active, payload }: TooltipProps<number, string>) {
  if (!active || !payload || payload.length === 0) return null;
  const p = payload[0]?.payload as { dimension: string; value: number | null } | undefined;
  if (!p) return null;
  return (
    <div className="rounded-lg border border-black/10 bg-white px-3 py-2 text-xs shadow-sm">
      <div className="font-semibold text-ink">{p.dimension}</div>
      <div className="text-ink-soft">Mean {fmt(p.value)}</div>
    </div>
  );
}

// View 1 — mean per dimension across all 15 axes, one accent polygon.
export function SpiderView({ data }: { data: SpiderRow[] }) {
  const chartData = data.map((d) => ({ dimension: d.name, value: d.mean }));
  const hasData = chartData.some((d) => d.value !== null);

  if (!hasData) {
    return <p className="py-12 text-center text-sm text-ink-soft">No dimension means available yet.</p>;
  }

  return (
    <div className="h-[440px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={chartData} outerRadius="70%" margin={{ top: 16, right: 24, bottom: 16, left: 24 }}>
          <PolarGrid stroke="#e5e5e5" />
          <PolarAngleAxis dataKey="dimension" tick={{ fontSize: 11, fill: '#4a4a4a' }} />
          <PolarRadiusAxis domain={[0, 5]} tickCount={6} angle={90} tick={{ fontSize: 10, fill: '#9ca3af' }} />
          <Radar
            name="Mean"
            dataKey="value"
            stroke="var(--accent)"
            strokeWidth={2}
            fill="var(--accent)"
            fillOpacity={0.3}
            isAnimationActive={false}
          />
          <Tooltip content={<RadarTooltip />} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
